import { asPage } from 'src/components/hoc/asPage'
import { ContentPage } from 'src/compositions/Content'

export default asPage(ContentPage, { pageTitle: '経営コラム', noindex: false })
